export default (toolName : string, toolId : string) => {
  window.TRACKING_TOOLS.set(toolName, {
    required_cookie_settings: toolName,
    initTracking () {
      // Start Baidu Code
      window._hmt = window._hmt || []
      const hm = document.createElement('script')
      hm.src = `https://hm.baidu.com/hm.js?${toolId}`
      const s = document.getElementsByTagName('script')[0]
      s.parentNode?.insertBefore(hm, s)
    },
  })
}
